import React from 'react';

export function NFISubject({subject}) {

    return <div className="pt-1 pb-0.5">
        <span style={{fontSize:'1.15rem',lineHeight:'1',fontWeight:'600'}}>{subject}</span>
    </div>
}